import { FC, useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
// import { Dialog, DialogContent, Typography } from '@mui/material';
import { useUnit } from 'effector-react';
import { $walletReloadInfoModalSecondsLate, setWalletReloadInfoModalSecondsLate } from '@entities/user/model';
import { LocalStorageKey } from '@shared/constants';
// import LazyImage from '../components/LazyImage';
// import close from './icons/close.svg';
import { toast } from 'react-toastify';
import { Bullhorn } from 'mdi-material-ui';
import { isMobile } from '@shared/utils';

const SECONDS_TO_OPEN = 15;

export const WalletReloadInfoModal: FC = () => {
  const t = useTranslations();
  const [reloadSecondsLate, setReloadSecondsLate] = useUnit([
    $walletReloadInfoModalSecondsLate,
    setWalletReloadInfoModalSecondsLate
  ]);
  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    return () => {
      setReloadSecondsLate(null);
    };
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    let currentSeconds = typeof reloadSecondsLate === 'number' ? reloadSecondsLate : -1;
    const connectedWallet = localStorage.getItem(LocalStorageKey.connectedWalletType);

    if (currentSeconds === -1 || connectedWallet !== 'metamask') {
      return;
    }

    if (currentSeconds === SECONDS_TO_OPEN) {
      // setIsOpened(true);
      setReloadSecondsLate(SECONDS_TO_OPEN);

      return;
    }

    const interval = setInterval(() => {
      currentSeconds += 1;
      console.log(`currentSeconds ${currentSeconds}`);

      if (currentSeconds === SECONDS_TO_OPEN) {
        clearInterval(interval);
        // setIsOpened(true);
        setReloadSecondsLate(SECONDS_TO_OPEN);

        return;
      }
    }, 1000);

    return () => {
      // setReloadSecondsLate(currentSeconds === -1 ? null : currentSeconds);
      clearInterval(interval);
    };
  }, [reloadSecondsLate]);

  useEffect(() => {
    if (typeof reloadSecondsLate !== 'number') {
      setIsOpened(false);
    }
  }, [reloadSecondsLate]);

  useEffect(() => {
    const id = Math.random();
    if (isOpened) {
      if (!isMobile()) {
        return;
      }

      toast.info(t('common.toast.reload_wallet'), {
        autoClose: false,
        toastId: id,
        style: { width: '100%', fontSize: '12px' },
        position: 'top-center',
        icon: () => <Bullhorn style={{ color: 'rgb(64, 191, 255)' }} />,
        closeOnClick: false
      });
    } else {
      toast.dismiss();
    }
  }, [isOpened, t]);

  return null;

  return (
    <></>
    // <Dialog
    //   open={isOpened}
    //   onClose={() => setIsOpened(false)}
    //   PaperProps={{
    //     sx: { zIndex: 1 }
    //   }}
    // >
    //   <DialogContent
    //     sx={{
    //       // px: { xs: 4, sm: 6 },
    //       // py: { xs: 4, sm: 6 },
    //       position: 'relative',
    //       maxWidth: 450,
    //       background: '#1C1929',
    //       display: 'grid',
    //       gap: 0
    //       // pb: 2
    //     }}
    //     style={{ paddingTop: 15, paddingBottom: 15 }}
    //   >
    //     <LazyImage
    //       style={{ position: 'absolute', top: '5px', right: '5px', cursor: 'pointer' }}
    //       onClick={() => setIsOpened(false)}
    //       src={close}
    //       alt='close'
    //     />
    //     <Typography sx={{ color: 'white', fontSize: 12, textAlign: 'center' }} color='white' variant='body2'>
    //       Если долго не подключается Metamask, перезагрузите его или подключитесь через встроенный браузер кошелька.
    //       Также для более стабильного подключения вы можете зайти через другие кошельки, которые поддерживают Magnet.
    //     </Typography>
    //   </DialogContent>
    // </Dialog>
  );
};
